import type { NameType, Payload, ValueType } from 'recharts/types/component/DefaultTooltipContent';

import { Card } from '@/components/ui/card';
import { i18n } from '@/lib/i18n';
import type { ChartData } from '../types/chart';

export const TooltipContent = ({
  active,
  header = i18n.t('populationSize'),
  payload,
  children,
}: {
  header?: string;
  active?: boolean;
  payload?: Payload<ValueType, NameType>[];
  children: (args: ChartData[number]) => React.ReactNode;
}) => {
  if (!active || !payload?.length) {
    return null;
  }
  return (
    <Card className="max-w-48 rounded-md bg-card-foreground p-4 text-white">
      <h2 className="text-sm font-normal">{header}</h2>
      {children(payload[0].payload)}
    </Card>
  );
};
